import React from "react";

import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/hooks/hook";

const PublicRoute = () => {
  const { accessToken } = useAppSelector((store: any) => store.user);

return  <Outlet />;

};

export default PublicRoute;
